import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import { MaterialModule } from '../../shared/material/material.module';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { DataService } from '../services/data.service';
import { AuthService } from '../services/auth.service';
import { AlphaNumericOnlyDirective } from 'app/shared/directives/alpha-numeric-only.directive';
// import { environmentDev } from '@env/environment.development';
import { environment } from '@env/environment';
 
declare var grecaptcha: any;
 
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [MaterialModule, ReactiveFormsModule, ToastrModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public loginForm!: FormGroup;
  public hide: boolean = true;
  public showPassword: boolean = true;
  public captcha: string = '';
  public captchaInp: string = '';
 
  constructor(
    private toastr: ToastrService,
    private dataServ: DataService,
    private authservice: AuthService,
    private formBuilder: FormBuilder
  ) {}
 
  recaptchaWidgetId: number | undefined;
 
  ngOnInit(): void {
    // this.initializeRecaptcha();
 
    this.authservice.checkLoggedInUser();
 
    this.dataServ.resetLogin.subscribe((data: boolean) => {
      if (data === true) {
        this.initializeLoginForm();
      }
    });
 
    this.initializeLoginForm();
    this.generateCaptcha();
  }
 
 
  public togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
 
  
  onSubmit(): void {
    const { username, password, captchaInp } = this.loginForm.value;
    if (captchaInp == '' && username !== '' && password !== '') {
      this.generateCaptcha();
      this.toastr.warning('Captcha is empty');
      return;
    }
 
    if (this.captcha !== captchaInp && username !== '' && password !== '') {
      this.generateCaptcha();
      this.toastr.warning('Invalid Captcha');
      return;
    }
 
    if (this.loginForm.valid) {
      const cred = this.loginForm.value;
      this.authservice.login(cred.username, cred.password, true);
    } else if (!username && !password) {
      this.toastr.warning('All fields are empty');
    } else {
      this.toastr.warning('All fields are required');
    }
  }
 
  private initializeLoginForm(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      captchaInp: ['', Validators.required],
    });
  }
 
  generateCaptcha(length: number = 6) {
    this.captchaInp = '';
    const characters: string =
      'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
 
    let captcha: string = '';
    for (let i = 0; i < length; i++) {
      const randomIndex: number = Math.floor(Math.random() * characters.length);
      captcha += characters.charAt(randomIndex);
    }
 
    this.captcha = captcha;
  }
 
  public changeStatus(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
  }
  // initializeRecaptcha() {
  //   // setTimeout(() => {
  //   //   this.recaptchaWidgetId = grecaptcha.render('your-recaptcha-container-id', {'sitekey': environmentDev.captchaKey,});
  //   // }, 100);
 
  //   setTimeout(() => {
  //     this.recaptchaWidgetId = grecaptcha.render(
  //       'your-recaptcha-container-id',
  //       { sitekey: environment.captchaKeyLocal }
  //     );
  //   });
  // }
}
 
 
